import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FirstService } from './first.service';

@Component({
  selector: 'app-first',
  imports: [],
  templateUrl: './first.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './first.component.css'
})
export class FirstComponent {

  private service = inject(FirstService);

  onClick() {
    console.log('Button clicked!');
    this.service.fetchData().subscribe(data => {
      console.log('Data fetched:', data);
    });
  }
}
